import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../../components/ui/card';
import PeakUsageDistribution from './PeakUsageDistribution';
import MostActiveUsers from './MostActiveUsers';
import SessionMetrics from './SessionsMetrics';
import SessionStats from './SessionStats';
import SessionHeatMap from './SessionHeatMap';

const SessionEngagementAnalytics = () => {
  return (
    <div className="innerpage detailed-page">
      <div className="w-full">
        <div className="mb-6">
          <h4 className="text-lg font-semibold mb-0">
            Session & Engagement Analytics
          </h4>
          <p className="text-muted-foreground text-sm mb-0">
            Detailed metrics on user sessions, engagement patterns, and
            activity levels
          </p>
        </div>

        {/* Stats Cards */}
        <SessionStats />

        {/* Charts */}
        <div className="mb-6">
          <Card className="shadow-sm border-0">
            <CardHeader>
              <CardTitle className="text-base font-bold">Session Activity Summary</CardTitle>
              <CardDescription className="text-sm">
                Time based session trends
              </CardDescription>
            </CardHeader>
            <CardContent>
              <SessionMetrics />
            </CardContent>
          </Card>
        </div>

        <div className="mb-6">
          <Card className="shadow-sm border-0">
            <CardHeader>
              <div className="flex items-baseline gap-2">
                <CardTitle className="text-base font-bold">Peak Usage Times</CardTitle>
                <small className="text-muted-foreground">(Today UTC)</small>
              </div>
              <CardDescription className="text-sm">
                Hourly session distribution
              </CardDescription>
            </CardHeader>
            <CardContent>
              <PeakUsageDistribution />
            </CardContent>
          </Card>
        </div>

        <div className="mb-6">
          <Card className="shadow-sm border-0">
            <CardHeader>
              <CardTitle className="text-base font-bold">Most Active Users</CardTitle>
              <CardDescription className="text-sm">
                Top users by session count
              </CardDescription>
            </CardHeader>
            <CardContent>
              <MostActiveUsers />
            </CardContent>
          </Card>
        </div>

        <div className="mb-6">
          <Card className="shadow-sm border-0">
            <CardHeader>
              <div className="flex items-baseline gap-2">
                <CardTitle className="text-base font-bold">Session Heatmap</CardTitle>
                <small className="text-muted-foreground">(UTC)</small>
              </div>
              <CardDescription className="text-sm">
                Logins by day of week and hour
              </CardDescription>
            </CardHeader>
            <CardContent>
              <SessionHeatMap />
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SessionEngagementAnalytics;
